const compact = (value) =>
  Object.fromEntries(
    Object.entries(value).filter(([, item]) => item !== undefined && item !== null && item !== '')
  )

const stableKey = (value = '') =>
  String(value)
    .replace(/^drafts\./, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')

export function listingBusinessId(listing = {}) {
  const id = listing._id || listing.slug?.current || listing.slug
  return listing.analytics?.businessId || (id ? `business:${stableKey(id)}` : undefined)
}

export function listingAnalyticsAttributes(listing = {}, position) {
  const sanityId = String(listing._id || listing.slug?.current || listing.slug || 'unknown').replace(
    /^drafts\./,
    ''
  )
  const businessId = listingBusinessId(listing) || `business:${stableKey(sanityId)}`

  return compact({
    'data-analytics-listing-id': `selong_guide:listing:${sanityId}`,
    'data-analytics-business-id': businessId,
    'data-analytics-business-name': listing.location,
    'data-analytics-business-category': listing.category,
    'data-analytics-business-area': listing.area,
    'data-analytics-business-section': listing.sectionPage,
    'data-analytics-editors-pick': String(Boolean(listing.editorsPick)),
    'data-analytics-position': Number.isFinite(Number(position)) ? String(position) : undefined,
  })
}
export function analyticsModuleAttributes(module = {}, type = 'content', position, heading) {
  const moduleId = module._key || module.analyticsId
  return compact({
    'data-analytics-module-id': moduleId,
    'data-analytics-module-type': type,
    'data-analytics-position': Number.isFinite(Number(position)) ? String(position) : undefined,
    'data-analytics-section-heading': heading,
  })
}
